import FingerprintJS from '@fingerprintjs/fingerprintjs';

export const getSessionId = () => {
    let sessionId = sessionStorage.getItem("sessionId");
    if (!sessionId) {
      sessionId = crypto.randomUUID(); // Generates a unique identifier
      sessionStorage.setItem("sessionId", sessionId);
    }
    return sessionId;
  };
  export const getVisitorId = async () => {
    const localStorageKey = 'visitor_id';
  
    // Check if the visitor ID exists in local storage
    const existingVisitorId = localStorage.getItem(localStorageKey);
    if (existingVisitorId) {
      return existingVisitorId;
    }
  
    // Generate a new visitor ID using FingerprintJS
    const fp = await FingerprintJS.load();
    const result = await fp.get();
  
    // Store the visitor ID in local storage
    localStorage.setItem(localStorageKey, result.visitorId);
  
    return result.visitorId;
  };
  // export const getDeviceId = () => {
  //   console.log(navigator,"navigator=========>");
    
  //   const rawDeviceData = `${navigator.userAgent}-${navigator.platform}-${navigator.language}`;
  //   return btoa(rawDeviceData); // Base64 encode for simplicity
  // };
  export const getPageUrl = () => window.location.href;
  const getTimestamp = () => new Date().toISOString();
  const getIpAddress = async () => {
    try {
      const response = await fetch("https://api.ipify.org?format=json");
      console.log(response,"ip response");
      
      const data = await response.json();
      return data.ip; // Returns the IP address
    } catch (error) {
      console.error("Failed to fetch IP address:", error);
      return null;
    }
  };
  const getBrowserDetails = () => ({
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    language: navigator.language,
  });
  const getReferrer = () => document.referrer || null;
  export const getLocationData = () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            resolve({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
              accuracy: position.coords.accuracy,
            });
          },
          error => {
            console.error("Geolocation error:", error);
            resolve(null);
          }
        );
      } else {
        console.warn("Geolocation is not supported by this browser.");
        resolve(null);
      }
    });
  };
  export const getCampaignData = () => {
    const params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get("utm_source") || null,
      utm_medium: params.get("utm_medium") || null,
      utm_campaign: params.get("utm_campaign") || null,
      utm_term: params.get("utm_term") || null,
      utm_content: params.get("utm_content") || null,
      qrscan: params.get("qrscan") || null,
      eic: params.get("eic") || null,
    };
  };
  export const getBrowserInfo = () => {
    const userAgent = navigator.userAgent;
  
    // Order matters: some browsers include others' names in their userAgent
    if (userAgent.includes("Edg/")) {
      return "Microsoft Edge";
    } else if (userAgent.includes("OPR/") || userAgent.includes("Opera")) {
      return "Opera";
    } else if (userAgent.includes("Chrome")) {
      return "Google Chrome";
    } else if (userAgent.includes("Safari")) {
      return "Safari";
    } else if (userAgent.includes("Firefox")) {
      return "Mozilla Firefox";
    } else if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
      return "Internet Explorer";
    } else {
      return "Unknown Browser";
    }
  };
  export const getDeviceName = () => {
    const platform = navigator.platform.toLowerCase();
    if (platform.includes("win")) return "windows";
    if (platform.includes("mac")) return "mac";
    if (platform.includes("linux")) return "linux";
    if (platform.includes("iphone") || platform.includes("ipad")) return "ios";
    if (platform.includes("android")) return "android";
    return "unknown";
  };

 const getLocation = async (lat, lon) => {
    try {
      const response = await fetch( "https://nominatim.openstreetmap.org/reverse?format=json&lat=" +
      lat +
      "&lon=" +
      lon);
      const data = await response.json();
      return {
        country: data.address.country || "unknown",
        city: data.address.city || "unknown",
        allData: data || "unknown"
      };
    } catch (error) {
      console.error("Error fetching location:", error);
      return { country: "unknown", city: "unknown",allData: "unknown" };
    }
  };

  
export const getGeoLocation = () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject('Geolocation not supported');
      }
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
  
          try {
            // Fetch detailed location data using latitude and longitude
            const locationDetails = await getLocation(latitude, longitude);
            // Resolve combined result: latitude, longitude, and detailed location
            resolve({
              latitude,
              longitude,
              ...locationDetails,
            });
          } catch (error) {
            console.error('Error fetching location details:', error);
            // Fallback with unknown location
            resolve({
              latitude,
              longitude,
              country: 'unknown',
              city: 'unknown',
            });
          }
        },
        (error) => reject(error.message)
      );
    });
  };
  
  const startTime = performance.now();

const getTimeSpent = () => {
  const endTime = performance.now();
  return (endTime - startTime) / 1000; // Time in seconds
};
const getScrollDepth = () => {
  const scrollTop = window.scrollY;
  const docHeight = document.documentElement.scrollHeight - window.innerHeight;
  return Math.min((scrollTop / docHeight) * 100, 100); // Percentage scrolled
};
